// Convert various timestamp representations to milliseconds since epoch.
// - Numbers in seconds are assumed to be in seconds and converted to ms.
// - Numbers already in ms are returned as-is.
// - Numeric strings are parsed and normalized.
// - Date strings are parsed via Date.parse.
export function toTimestampMs(value) {
  if (value == null) return NaN;

  if (typeof value === 'number') {
    if (!Number.isFinite(value)) return NaN;
    // Heuristic: values < 1e12 are seconds, convert to ms
    return value < 1e12 ? Math.floor(value * 1000) : Math.floor(value);
  }

  if (typeof value === 'string') {
    const asNum = Number(value);
    if (!Number.isNaN(asNum) && asNum !== 0) {
      return toTimestampMs(asNum);
    }
    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? NaN : parsed;
  }

  if (value instanceof Date) return value.getTime();

  return NaN;
}

/**
 * Format an ISO 8601 timestamp into local `HH:MM` (24-hour) or return null.
 * Returns null for falsy or unparsable inputs.
 *
 * @param {string|undefined|null} iso
 * @returns {string|null}
 */
export function formatIsoToLocalHHMM(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  // Use locale-aware 12-hour format with AM/PM
  return new Intl.DateTimeFormat(undefined, {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(d);
}
